import { css } from "@emotion/react";

export const DropdownMenuStyle = {
  index: (isActive: boolean, language: string) => css`
    margin: 0 auto;
    position: absolute;
    left: 0;
    right: 0;
    top: 65px;
    z-index: 8;
    width: 100%;
    overflow: hidden;
    background: linear-gradient(to bottom, #fafafaff 0%, #ffffff 33%, #fafafaff);
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    
    .bg_menuShadow {
      width: 100%;
      position: absolute;
      top: 0px;
      background-image: url(${`/common/desktop/menu/bg_menuShadow.png`});
      height: 4px;
      z-index: 8;
    }

    .subList {
      margin: 0 auto;
      position: relative;
      width: 1000px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s;
      height: ${isActive ? "auto" : 0} !important;
      flex-wrap: wrap;
      gap: 12px;
      padding-top: ${isActive ? "12px" : "0"};
    }
  `,
  item: () => css`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: auto;
    height: 100%;
    padding: 0px 6px;
    border-radius: 8px;

    &:hover {
      background: linear-gradient(
        to bottom,
        rgba(219, 232, 251, 1) 0%,
        rgba(219, 232, 251, 0.2) 100%
      );
    }

    .Darkened2 {
      width: 175px;
      object-fit: contain;
    }

    .listLogo {
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 50%;

      .img_logo {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 100%;
        max-width: 60px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .listName {
        white-space: nowrap;
        color: #091437;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        margin-top: 4px;
        font-weight: 500;
      }
    }
  `,
};
